import React from 'react'
import IndustrialHero from './IndustrialHero'
import IndustrialContent from './IndustrialContent'
import IndustrialServices from './IndustrialServices'
import IndustrialTrustSection from './Industrialsection'
import IndustrialTransform from './IndustrialTransform'
import Footer from '../../Footer/Footer'










function IndustrialCorporate() {
    return (
        <div>
            <IndustrialHero/>
            <IndustrialContent/>
            <IndustrialServices/>
            <IndustrialTrustSection/>
            <IndustrialTransform/>
            <Footer/>
            
        </div>
    )
}

export default IndustrialCorporate
